import { Position } from '../types/protocol.js';


export function getPositionSymbolFinal(
    position: Position,
): string {
    return position.isCritical ? '◆' : position.symbol ?? '';
}
